import AppPageEmpty from '@/components/app-page/index-empty.vue';

export default [{
  path: '/event-manage-realtime',
  name: 'EventManageRealTime',
  component: AppPageEmpty,
  meta: {
    title: '事件分析（实时）',
    style: 's-help',
  },
  children: [
    {
      path: 'list',
      name: 'EventListRealTime',
      component: () => import('@/views/event-manage-realtime/list/index.vue'),
      meta: {
        title: '事件列表',
        style: 'tickets',
        activeMenu: '/event-manage-realtime/list',
        isUseAppInfo: true,
      },
    },
    {
      path: 'pageEventAnalysis',
      name: 'pageEventAnalysisRealTime',
      component: () => import('@/views/event-manage-realtime/page-analysis/index.vue'),
      meta: {
        title: '页面事件分析',
        style: 's-data',
        activeMenu: '/event-manage-realtime/pageEventAnalysis',
        isUseAppInfo: true,
      },
    },
    {
      path: 'eventAnalysis',
      name: 'EventAnaylysisRealTime',
      component: () => import('@/views/event-manage-realtime/analysis/index.vue'),
      meta: {
        title: '事件分析',
        style: 'sunny',
        activeMenu: '/event-manage-realtime/eventAnalysis',
        isNotMenu: true,
        isUseAppInfo: true,
      },
    },
  ],
}];
